import Marionette from 'backbone.marionette';
import memberDetailItemviewTmpl from '../templates/member_detail_itemview.tpl';
export default Marionette.ItemView.extend({
  template: memberDetailItemviewTmpl
});